import React from 'react';
import { connect } from 'react-redux';

import AuthenticationGate from './AuthenticationGate';

import { selectIsAuthenticated } from '../../redux/auth/user/selectors';

const AuthenticationGateConnected = (props) => <AuthenticationGate {...props} />;

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
});

export default connect(mapStateToProps)(AuthenticationGateConnected);
